import Copy from "@components/global/new/Copy/Copy";
import styles from "./FormInput.module.scss";
import { useEffect, useState } from "react";
import FormattedInput from "@components/global/FormattedInput";
import cn from "classnames";
import { Input } from "@components/global/new/Input/Input";

import { RefObject } from "react";
import { FormInstance } from "antd";
import { IMinerMeta } from "@services/changeMinerSettings";

interface IFormInputProps {
  readonly label: string;
  readonly inititalValue?: string;
  readonly type: keyof IMinerMeta;
  readonly showCopy?: boolean;
  readonly formRef: RefObject<FormInstance<any>>;
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly className?: string;

  onInputChecker(value: string, key: keyof IMinerMeta): void;
}

export default function FormInput({ ...props }: IFormInputProps) {
  const [value, setValue] = useState<string>(
    props.inititalValue || props.placeholder || ""
  );
  useEffect(() => {
    props.onInputChecker(value, props.type);
    props.formRef.current?.setFieldValue(props.type, value);
  }, [value]);

  useEffect(() => {
    if (props.type === "password") {
      setValue(props.inititalValue || props.placeholder || "");
    } else {
      setValue(props.inititalValue || "");
    }
  }, [props.inititalValue, props.placeholder]);

  return (
    <Input
      inputType={props.type === "password" ? "password" : "text"}
      copyButton
      outlined={!props.disabled}
      addonBefore={props.label}
      allowClear={true}
      readOnly={props.disabled}
      onChange={v => setValue(v.target.value)}
      placeholder={props.placeholder}
      size="small"
      tabIndex={-1}
      value={value}
      wrapClassName={props.className}
    />
  );
}
